import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template", "field"]

  connect() {
    this.wrapperClass = "nested-field"
    this.index = new Date().getTime()
  }

  addField(event) {
    event.preventDefault()
    
    const template = this.templateTarget
    const newField = template.content.cloneNode(true)
    
    // Replace NEW_RECORD with unique timestamp
    const timestamp = new Date().getTime()
    this.replaceIds(newField, timestamp)
    
    // Insert before the add button
    const addButton = event.target
    this.containerTarget.insertBefore(newField, addButton)
  }

  removeField(event) {
    event.preventDefault()
    
    const field = event.target.closest('.nested-field')
    
    // If this is a persisted record, mark for destruction
    const destroyInput = field.querySelector('input[name*="_destroy"]')
    if (destroyInput) {
      destroyInput.value = '1'
      field.style.display = 'none'
    } else {
      // Just remove if it's a new record
      field.remove()
    }
  }

  replaceIds(template, timestamp) {
    const elements = template.querySelectorAll('[name*="NEW_RECORD"], [id*="NEW_RECORD"], [for*="NEW_RECORD"], [data-clipboard-input-target*="NEW_RECORD"]')
    
    elements.forEach(element => {
      if (element.name) {
        element.name = element.name.replace(/NEW_RECORD/g, timestamp)
      }
      if (element.id) {
        element.id = element.id.replace(/NEW_RECORD/g, timestamp)
      }
      if (element.getAttribute('for')) {
        element.setAttribute('for', element.getAttribute('for').replace(/NEW_RECORD/g, timestamp))
      }
      if (element.getAttribute('data-clipboard-input-target')) {
        element.setAttribute('data-clipboard-input-target', 
          element.getAttribute('data-clipboard-input-target').replace(/NEW_RECORD/g, timestamp))
      }
    })
  }
}
